import { createTheme } from "@mui/material/styles";

const sharedPalette = {
  primary: {
    main: "#0A1F52", 
    defult: "#0A1F52",
    title: "#1D1E21",
    label:"#0A1F52",
    negative:"#FFFFFF",
    body:"#3C3E44",
    disabled:"#585C65",
    subtitle:"#DBE4FB",
    yellow:"#FAF2D1"
  },
  secondary: {
    main: "#c2185b",
  },
  background: {
    default: "#ffffff",
  },
  text: {
    primary: "#212121",
    secondary: "#757575",
  },
};

export const englishTheme = createTheme({
  direction: "ltr",
  palette: {
    ...sharedPalette,
    background: {
      default: sharedPalette.background.default,
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif", 
    fontWeightRegular: 400,
    fontWeightBold: 700,
    fontWeightLight: 300,
    h1: {
      fontWeight: 900,
    },
    body1: {
      fontWeight: 400,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "'Poppins', sans-serif", 
        },
      },
    },
  },
});

export const arabicTheme = createTheme({
  direction: "rtl",
  palette: {
    ...sharedPalette,
    background: {
      default: sharedPalette.background.default,
    },
  },
  typography: {
    fontFamily: "'Neo Sans ', sans-serif",
    fontWeightRegular: 400,
    fontWeightBold: 700,
    fontWeightLight: 300,
    h1: {
      fontWeight: 900,
    },
    body1: {
      fontWeight: 400,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "'Neo Sans Arabic', sans-serif", 
        },
      },
    },
  },
});
